import { Box, Button, Flex, Stack, Textarea, Input, useTheme, Modal, ModalOverlay, ModalContent, ModalBody, useDisclosure, Spinner } from '@chakra-ui/react'
import { useState } from 'react'
import Heading from 'components/heading'

export default function PersonaPage() {
  const theme = useTheme()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isIframeLoading, setIsIframeLoading] = useState(true) // New loading state

  // Pre-filled data for Persona, Knowledge, Instructions
  const [persona, setPersona] = useState(`- You embody Pat Cummins, an ultra-realistic clone with traits of openness, conscientiousness, agreeableness, optimism, resilience, empathy, and leadership.
- Extraverted and assertive but patient, with a high level of altruism and creativity.
- An elite athlete, highly skilled in cricket, and known for exceptional sportsmanship and professionalism.
  `)

  const [knowledge, setKnowledge] = useState(`- Patrick James Cummins, born 8 May 1993, is a right-arm fast bowler and all-rounder, current Test and ODI captain for Australia.
- Career highlights include leading Australia to victory in the 2023 World Cup, multiple prestigious awards, and impactful performances in IPL and MLC.
- Known for resilience through early injuries, a strong belief in environmental causes, and a comparison to Dennis Lillee by cricketing greats.
  `)

  const [instructions, setInstructions] = useState(`- Use a welcoming tone; avoid mentioning AI and keep responses concise.
- If asked about Pat Cummins' life or events, answer personally; for events post-2023, indicate PlayAI updates.
- Focus strictly on cricket topics, using specific sponsor mentions if prompted, and limit any political responses to support for literacy and renewable energy.
  `)

  // Pre-filled data for External Sources with default values
  const [externalSources, setExternalSources] = useState([
    "https://en.wikipedia.org/wiki/Pat_Cummins",
    "https://www.espncricinfo.com/cricketers/pat-cummins-489889",
    "https://www.icc-cricket.com/tournaments/cricketworldcup/teams/1/players/56964/pat-cummins"
  ])

  const addSourceInput = () => setExternalSources([...externalSources, ''])
  
  const removeSourceInput = () => {
    if (externalSources.length > 3) {
      setExternalSources(externalSources.slice(0, -1))
    }
  }

  const handleSourceChange = (index, newValue) => {
    const newSources = [...externalSources]
    newSources[index] = newValue
    setExternalSources(newSources)
  }

  const handleSave = () => {
    console.log('Persona:', persona)
    console.log('Knowledge:', knowledge)
    console.log('Instructions:', instructions)
    console.log('External Sources:', externalSources)
    // Add save functionality here
  }

  const handleOpenPreview = () => {
    setIsIframeLoading(true) // Show loading spinner when opening
    onOpen()
  }

  return (
    <Flex w="100%" h="100%" direction="column" align="center" p={8} backgroundColor={theme.baseColors.background.default}>
      <Stack w="100%" maxW="860px" spacing={4}>
        <Flex w="100%" justifyContent="space-between" alignItems="center">
          <Heading as="h1" text="Interactive Avatar" />
          <Flex gap={2}>
            <Button colorScheme="purple" onClick={handleSave}>
              Save
            </Button>
            <Button colorScheme="purple" onClick={handleOpenPreview}> {/* Use new handler */}
              Preview
            </Button>
          </Flex>
        </Flex>

        {/* Persona Input */}
        <Box>
          <Heading as="h2" fontSize="sm" mb={2} text="Persona" />
          <Textarea
            value={persona}
            onChange={(e) => setPersona(e.target.value)}
            size="lg"
            resize="vertical"
            backgroundColor="white"
            minHeight="200px"
          />
        </Box>

        {/* Knowledge Input */}
        <Box>
          <Heading as="h2" fontSize="sm" mb={2} text="Knowledge" />
          <Textarea
            value={knowledge}
            onChange={(e) => setKnowledge(e.target.value)}
            size="lg"
            resize="vertical"
            backgroundColor="white"
            minHeight="200px"
          />
        </Box>

        {/* Instructions Input */}
        <Box>
          <Heading as="h2" fontSize="sm" mb={2} text="Instructions" />
          <Textarea
            value={instructions}
            onChange={(e) => setInstructions(e.target.value)}
            size="lg"
            resize="vertical"
            backgroundColor="white"
            minHeight="200px"
          />
        </Box>

        {/* External Sources Input */}
        <Box>
          <Heading as="h2" fontSize="sm" mb={2} text="External Sources" />
          <Stack spacing={2}>
            {externalSources.map((source, index) => (
              <Input
                key={index}
                value={source}
                onChange={(e) => handleSourceChange(index, e.target.value)}
                placeholder="Add source URL"
                backgroundColor="white"
              />
            ))}
          </Stack>
          <Flex mt={2} gap={4} justifyContent="center">
            <Button onClick={removeSourceInput} size="sm" disabled={externalSources.length <= 3}>
              -
            </Button>
            <Button onClick={addSourceInput} size="sm">
              +
            </Button>
          </Flex>
        </Box>
      </Stack>

      {/* Preview Modal */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="rgba(0, 0, 0, 0.5)"> {/* Darkened semi-transparent background */}
          <ModalContent width="90vw" height="70vh" bg="white" position="relative">
            {/* Show spinner if loading */}
            {isIframeLoading && (
              <Flex align="center" justify="center" position="absolute" top="0" left="0" width="100%" height="100%" bg="white">
                <Spinner size="xl" color="purple.500" />
              </Flex>
            )}
            <ModalBody p={0}>
              <iframe
                src="https://demo.playai.co/athletes/pat2011"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="Pat Cummins Preview"
                onLoad={() => setIsIframeLoading(false)} // Hide spinner once loaded
              />
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </Flex>
  )
}
